import { AnyAction } from "redux";
import { Dispatch } from "react";
import { Result } from "../../../../interfaces";
import { Remove } from "../../../commons";

export const FETCH_DELETE_COMMONS_REQUEST = 'FETCH_DELETE_COMMONS_REQUEST';
export const FETCH_DELETE_COMMONS_SUCCESS = 'FETCH_DELETE_COMMONS_SUCCESS';
export const FETCH_DELETE_COMMONS_FAILURE = 'FETCH_DELETE_COMMONS_FAILURE';

interface ActionPagination<T> {
    type: string,
    payload: T
}

const fetchDeleteCommonsRequest = () => {
    return {
        type: FETCH_DELETE_COMMONS_REQUEST,
    };
};

const fetchDeleteCommonsSuccess = (data: any): ActionPagination<Result<any>> => {
    return {
        type: FETCH_DELETE_COMMONS_SUCCESS,
        payload: data
    };
};

const fetchDeleteCommonsFailure = (error: any) => {
    return {
        type: FETCH_DELETE_COMMONS_FAILURE,
        payload: error,
    };
};

export const remove = (id:string) => {
    return async (dispatch: Dispatch<AnyAction>) => {
        dispatch(fetchDeleteCommonsRequest());
        try {
            await Remove(id);
            dispatch(fetchDeleteCommonsSuccess(true));
        } catch (error: any) {
            dispatch(fetchDeleteCommonsFailure(error.message));
        }
    };
};
